import { capitalize } from "~/utils";

export const getStatusBadge = (status: string) => {
  let classes = "px-2 py-1 rounded-full text-xs font-medium ";

  switch (status.toLowerCase()) {
    case "completed":
      classes += "bg-green-100 text-green-800";
      break;
    case "in-progress":
      classes += "bg-blue-100 text-blue-800";
      break;
    case "scheduled":
      classes += "bg-purple-100 text-purple-800";
      break;
    case "estimated":
      classes += "bg-yellow-100 text-yellow-800";
      break;
    case "cancelled":
      classes += "bg-red-100 text-red-800";
      break;
    case "draft":
      classes += "bg-gray-100 text-gray-800";
      break;
    default:
      classes += "bg-gray-100 text-gray-800";
  }

  return <span className={classes}>{capitalize(status)}</span>;
};

// Function to render payment status badge
export const getPaymentBadge = (status: string) => {
  let classes = "px-2 py-1 rounded-full text-xs font-medium ";

  switch (status.toLowerCase()) {
    case "paid":
      classes += "bg-green-100 text-green-800";
      break;
    case "partial":
      classes += "bg-blue-100 text-blue-800";
      break;
    case "pending":
      classes += "bg-yellow-100 text-yellow-800";
      break;
    case "overdue":
      classes += "bg-red-100 text-red-800";
      break;
    default:
      classes += "bg-gray-100 text-gray-800";
  }

  return <span className={classes}>{capitalize(status)}</span>;
};
